import { Button, Card, Col, Modal } from "react-bootstrap";
import { AttachmentClass } from "./models/Attachment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash } from "@fortawesome/free-solid-svg-icons";
import React, { useContext, useState } from "react";
import { SoknaderContext } from "./contexts/SoknaderContext";

function VedleggCard(props: any) {

    const { soknadVedlegg, downloadFileFunction, deleteVedlegg, soknad, loadingVedlegg } = useContext(SoknaderContext);
    const readOnly: boolean = props.readOnly;
    const showFileUpload = props.showFileUpload;
    const [showModal, setShowModal] = useState(false);
    const [vedleggToDelete, setVedleggToDelete] = useState<number | null>(null)
    const handleCloseModal = () => {
        setVedleggToDelete(null);
        setShowModal(false);
    };
    const handleShowModal = () => setShowModal(true);

    if (loadingVedlegg) {
        return (
            <div>Laster vedlegg...</div>
        )
    }

    return (
        <>
            <Card>
                <Card.Header className={"bg-primary card-header-ext"}>
                    Vedlegg til søknaden
                </Card.Header>
                <Card.Body>
                    <div><Button disabled={readOnly || soknad.id===0} onClick={() => {

                        showFileUpload(true);


                    }}>Last opp nytt vedlegg</Button></div>
                    { soknad.id===0?
                        <span className={"text-muted form-control-sm"}>Søknaden må lagres før du kan laste opp vedlegg</span>
                        :null
                    }
                    <div className={"mt-2"}>
                        {(!soknadVedlegg || soknadVedlegg.length === 0) ?
                            <p>Ingen vedlegg å vise</p> :
                            <>
                                <Col md={12}>
                                    Liste over dine vedlegg:
                                </Col>
                                <Col md={12}>
                                    <ul>
                                        {
                                            soknadVedlegg.map((x: AttachmentClass) => {
                                                return (<li className={"mt-2"} key={x.id}>
                                                    <div>
                                                        {x.originalFileName}&nbsp;
                                                        <span style={{ cursor: "pointer" }}
                                                            onClick={() => downloadFileFunction(x)}><FontAwesomeIcon
                                                                icon={faEye}></FontAwesomeIcon></span>
                                                        &nbsp;
                                                        {
                                                            readOnly ? null :
                                                                <span style={{ cursor: "pointer" }}
                                                                    onClick={() => {
                                                                        if (x.id) {
                                                                            setVedleggToDelete(x.id);
                                                                            handleShowModal();
                                                                        }
                                                                    }}><FontAwesomeIcon
                                                                        color={"red"}
                                                                        icon={faTrash}></FontAwesomeIcon></span>
                                                        }
                                                    </div>
                                                </li>);
                                            })
                                        }
                                    </ul>
                                </Col>


                            </>}
                    </div>
                </Card.Body>
            </Card>
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Slett vedlegg</Modal.Title>
                </Modal.Header>
                <Modal.Body>Vil du slette vedlegget fra skjemaet?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Nei
                    </Button>
                    <Button variant="primary" onClick={() => {
                        setShowModal(false);
                        deleteVedlegg(vedleggToDelete);
                        setVedleggToDelete(null);
                    }}>
                        Ja, jeg er sikker!
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default VedleggCard